/**
 * 统一端 - 存储与读取用户信息
 */
import Cookies from 'js-cookie';

const { hostname } = window.location;
const shipperUserKey = 'ShippersUserInfo';

/**
 * 根据 hostname 获取域名路径
 */
function getDomainPath() {
  if (hostname.indexOf('.nucarf.net') !== -1) {
    return '.nucarf.net';
  } else if (hostname.indexOf('.nucarf.tech') !== -1) {
    return '.nucarf.tech';
  }
  return '';
}

/**
 * 获取统一端用户信息
 * @returns {object|null} 用户信息对象
 */
export function getShippersUserInfo() {
  const infoStr = Cookies.get(shipperUserKey);
  if (infoStr) {
    try {
      return JSON.parse(infoStr);
    } catch (e) {
      return null;
    }
  }
  return null;
}

/**
 * 设置统一端用户信息
 * @param {any} info - 用户信息对象
 */
export function setShippersUserInfo(info) {
  const path = getDomainPath();

  // 获取现有的用户信息
  const existingInfo = getShippersUserInfo();
  //获取name

  // 如果传入的是包含 accessToken 的对象，只更新 accessToken
  let updatedInfo;
  if (info && typeof info === 'object' && 'accessToken' in info && existingInfo) {
    updatedInfo = {
      ...existingInfo,
      accessToken: info.accessToken,
      userName: info.userName,
      phoneNo: info.phoneNo,
    };
  } else {
    // 否则直接使用传入的信息
    updatedInfo = info;
  }

  const infoStr = JSON.stringify(updatedInfo);

  if (path) {
    Cookies.set(shipperUserKey, infoStr, { domain: path });
  } else {
    Cookies.set(shipperUserKey, infoStr);
  }
}

/**
 * 根据环境获取跳转地址
 * @returns {string} 跳转地址
 */
export function getShippersUrl(path) {
  if (hostname.indexOf('qa') !== -1) {
    // 生产环境
    return `https://qa-shippers.nucarf.tech/w/shippers/${path}`;
  } else if (hostname.indexOf('.nucarf.tech') !== -1) {
    // 开发/测试环境
    return `https://ci-shippers.nucarf.tech/w/shippers/${path}`;
  } else if (hostname.indexOf('pre') !== -1) {
    // 生产环境
    return `https://pre-shippers.nucarf.net/w/shippers/${path}`;
  } else if (hostname.indexOf('.nucarf.net') !== -1) {
    // 生产环境
    return `https://vip.nucarf.net/w/shippers/${path}`;
  }
  // 默认返回测试环境地址
  return `https://ci-shippers.nucarf.tech/w/shippers/${path}`;
}
